/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Select_DeveloperInputs */

const en_options_cli_select_developer = /** @type {(inputs: Options_Cli_Select_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Developer`)
};

const fr_options_cli_select_developer = /** @type {(inputs: Options_Cli_Select_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner le développeur`)
};

const de_options_cli_select_developer = /** @type {(inputs: Options_Cli_Select_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwickler auswählen`)
};

const it_options_cli_select_developer = /** @type {(inputs: Options_Cli_Select_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona Sviluppatore`)
};

const ru_options_cli_select_developer = /** @type {(inputs: Options_Cli_Select_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите разработчика`)
};

const es_options_cli_select_developer = /** @type {(inputs: Options_Cli_Select_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar desarrollador`)
};

const zh_cn2_options_cli_select_developer = /** @type {(inputs: Options_Cli_Select_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择开发商`)
};

const ja_options_cli_select_developer = /** @type {(inputs: Options_Cli_Select_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発者を選択`)
};

const hi_options_cli_select_developer = /** @type {(inputs: Options_Cli_Select_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेवलपर का चयन करें`)
};

const pt_pt2_options_cli_select_developer = /** @type {(inputs: Options_Cli_Select_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o desenvolvedor`)
};

/**
* | output |
* | --- |
* | "Select Developer" |
*
* @param {Options_Cli_Select_DeveloperInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_select_developer = /** @type {((inputs?: Options_Cli_Select_DeveloperInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Select_DeveloperInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_select_developer(inputs)
	if (locale === "de") return de_options_cli_select_developer(inputs)
	if (locale === "it") return it_options_cli_select_developer(inputs)
	if (locale === "ru") return ru_options_cli_select_developer(inputs)
	if (locale === "es") return es_options_cli_select_developer(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_select_developer(inputs)
	if (locale === "ja") return ja_options_cli_select_developer(inputs)
	if (locale === "hi") return hi_options_cli_select_developer(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_select_developer(inputs)
	return en_options_cli_select_developer(inputs)
});